import React, { ReactNode } from 'react';

interface Step {
  icon: ReactNode;
  title: string;
  description: string;
}

const HowWeBuild: React.FC = () => {
  const steps: Step[] = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      ),
      title: 'Real data from your target market',
      description: 'We source actual salary benchmarks, employer tax rates, verified acquisition costs, and competitive intelligence from companies already operating in your target market and industry. Every number has a source.'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      ),
      title: 'Your numbers, modelled across three scenarios',
      description: 'Your pricing, team structure, and budget are combined with real market data to model how your expansion most likely plays out. Conservative, base, and optimistic so you see the full range before you commit.'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
          <line x1="22" y1="2" x2="11" y2="13" />
          <polygon points="22 2 15 22 11 13 2 9 22 2" fill="none" />
        </svg>
      ),
      title: 'A clear verdict in 72 hours',
      description: 'You receive a complete 12-month breakdown you can follow from month zero to month twelve. Watch your revenue build, costs accumulate, and your cash position evolve so you see exactly how your expansion is projected to unfold.'
    }
  ];

  return (
    <section className="how-section">
      <div className="how-inner">
        <div className="section-label"><span>How We Build Your Simulation</span></div>
        <h2 className="section-title">Built on real data.<br /><em>Specific to your expansion.</em></h2>
        <p className="section-sub">Every simulation is built from scratch around your company, your target market, and your numbers. Not a template. Not a generic report. A simulation you can actually make decisions from.</p>
        <div className="steps-row">
          {steps.map((step, index) => (
            <div key={index}>
              <div className="step-icon">{step.icon}</div>
              <h4>{step.title}</h4>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeBuild;
